import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./BillingSystem.css";

export default function BossNavigation() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const toggleSidebar = () => setOpen(!open);

  return (
    <>
      {!open && (
        <button className="menu-button" onClick={toggleSidebar}>
          ☰
        </button>
      )}

      <div className={`sidebar ${open ? "open" : ""}`}>
        <button className="close-btn" onClick={toggleSidebar}>
          ×
        </button>

        <h3>📋 Menu</h3>

        <ul>
          <li>
            <button onClick={() => { navigate("/"); setOpen(false); }}>
              🏠 Home
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/owner"); setOpen(false); }}>
              📄 Billing
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/owner-add-user"); setOpen(false); }}>
              ➕ Add User
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/raw-stock"); setOpen(false); }}>
              🧱 Raw Stock
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/production"); setOpen(false); }}>
              🏭 Production
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/customer-sales"); setOpen(false); }}>
              📊 Sales Insights
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/saleman-report"); setOpen(false); }}>
              👨‍💼 Salesman Report
            </button>
          </li>

          {/* Bottlers System */}
          <li>
            <button onClick={() => { navigate("/bottlers"); setOpen(false); }}>
              💧 Bottlers Entry
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/manage-prices"); setOpen(false); }}>
              💰 Manage Prices
            </button>
          </li>

          {/* Enterprises */}
          <li>
            <button onClick={() => { navigate("/enterprises"); setOpen(false); }}>
              🏭 Enterprises Entry
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/expenses"); setOpen(false); }}>
              💸 Expenses
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/opening-stock"); setOpen(false); }}>
              📥 Stock
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/attendance"); setOpen(false); }}>
              🕒 Auto Attendance
            </button>
          </li>
           <li>
            <button onClick={() => { navigate("/manual-entry"); setOpen(false); }}>
              📝 Manual Attendance
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/attendance-report"); setOpen(false); }}>
              📊 Attendance Report
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/add-employee"); setOpen(false); }}>
              ➕ Add Employee
            </button>
          </li>

          <li>
            <button onClick={() => { navigate("/employees"); setOpen(false); }}>
              👥 Employees List
            </button>
          </li>
        </ul>
      </div>
    </>
  );
}